import React, { useState } from "react";
import { toggle } from "../../../util/common";
import { WalletItemGenericID } from "../../../store/common";
import { DialogComponent } from "../../common/DialogComponent";
import ConfirmDeleteWalletDialog from "../../Dialogs/lostWallet/ConfirmDeleteWalletDialog";
import IdCardDialog from "../../Dialogs/lostWallet/IdCardDialog";
import i18nService from "../../../util/Internationalization/i18n/i18n";
import { useTranslation } from "react-i18next";
import { getFormattedDate } from "../../../util/dateFormatting";

const IdCard: React.FunctionComponent<{ requestDataCallback(): void; walletItemGenericIDs: WalletItemGenericID[] }> = (props) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const [deleteWalletDialogIsVisible, setDeleteWalletDialogIsVisible] = useState(false);
    const [idCardDialogIsVisible, setIdCardDialogIsVisible] = useState(false);
    const [selectedItem, setSelectedItem] = useState({});
    const [idCardNumber,setIdCardNumber]:any =useState([]);
    const showDeleteWalletDialog = (selectedItem: WalletItemGenericID): any => {
        setSelectedItem(selectedItem);
        setDeleteWalletDialogIsVisible(true);
    };

    const closeDeleteWalletDialog = (): any => {
        setDeleteWalletDialogIsVisible(false);
    };

    const showIdCardDialog = (selectedItem: WalletItemGenericID): any => {
        setSelectedItem(selectedItem);
        setIdCardDialogIsVisible(true);
    };

    const closeIdCardDialog = (): any => {
        setIdCardDialogIsVisible(false);
    };
 const toggleCardNumVisibility=(idCard:any)=>{
    if (idCardNumber.length > 0) {
        const index = idCardNumber.findIndex((element: any) => element.cardNumber === idCard.cardNumber);
     if (index >= 0) {
        idCardNumber.splice(index, 1);
        setIdCardNumber([...idCardNumber]);
    } 
     else {
        setIdCardNumber([...idCardNumber, idCard]);
     }
      } else {
        setIdCardNumber([...idCardNumber , idCard]);
     }
 }
    return (
        <React.Fragment>
            {props.walletItemGenericIDs &&
                props.walletItemGenericIDs.map((idCard: WalletItemGenericID, index) => (
                    <div className="data-row" key={"id-card-" + index}>
                        <div className="link-item">
                            <button
                                type="button"
                                aria-expanded="false"
                                className="link-button"
                                id={"id-card-" + index}
                                onClick={() => toggle(`id-card-${index}-details`, `id-card-${index}`)}
                            >
                                <span className="row link-item">
                                    <span className="col-xs col-no-gutter link-text">
                                        <span className="link-title">
                                            <span className="sr-only btn-toggle-status">Show</span> {idCard.firstName + " " + idCard.lastName}
                                        </span>
                                        <span className="link-helper">
                                            <span className="sr-only">Item Type: </span>
                                            {tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.title2")}
                                        </span>
                                    </span>
                                </span>
                            </button>

                            <div className="wallet-details" id={"id-card-" + index + "-details"} style={{ display: "none" }}>
                                <div
                                    role="grid"
                                    className="data-grid row-height-xs"
                                    id={"id-card-" + index + "-title"}
                                    aria-labelledby={"id-card-" + index + "-title"}
                                >
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"id-card-" + index + "-card-type"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.label.cardType")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"id-card-" + index + "-card-type"}>
                                                {idCard.cardType}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"id-card-" + index + "-card-number"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.label.cardNumber")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"id-card-" + index + "-card-number"}>
                                              {idCard &&
                                                idCard.cardNumber && idCardNumber.findIndex((element: any) => element.cardNumber ===   idCard.cardNumber) < 0 ?
                                                      `${"X".repeat(idCard.cardNumber.substr(0, idCard.cardNumber.length - 4).length)}${idCard.cardNumber.substr(
                                                        idCard.cardNumber.length - 4
                                                      )}`: idCard.cardNumber } 
                                                      <button
                                                type="button"
                                                className="btn-default btn-icon-only btn-no-padding"
                                                onClick={() => {
                                                    toggleCardNumVisibility(idCard);
                                                }}
                                                title={"Show IDCardNumber Text"}
                                                style={{marginLeft: '1.25rem'}}
                                            >
                                                <span className="btn-icon">
                                                    <em
                                                        className={`las ${
                                                            idCardNumber.findIndex((element: any) => element.cardNumber ===   idCard.cardNumber) < 0 ? "la-eye" : "la-eye-slash"
                                                        }`}
                                                    ></em>
                                                </span>
                                                <span className="btn-text">Show / Hide IDCardnumber Text</span>
                                            </button>   
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"id-card-" + index + "-first-name"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.label.firstName")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"id-card-" + index + "-first-name"}>
                                                {idCard.firstName}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"id-card-" + index + "-middle-initial"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.label.middleInitial")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"id-card-" + index + "-middle-initial"}>
                                                {idCard.middleName}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"id-card-" + index + "-last-name"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.label.lastName")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"id-card-" + index + "-last-name"}>
                                                {idCard.lastName}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"id-card-" + index + "-suffix"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.label.suffix")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"id-card-" + index + "-suffix"}>
                                                {idCard.suffix}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"id-card-" + index + "-description"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.label.description")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"id-card-" + index + "-description"}>
                                                {idCard.description}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"id-card-" + index + "-issue-date"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.label.issueDate")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"id-card-" + index + "-issue-date"}>
                                                {idCard.issueDate && getFormattedDate(i18nService.get("Country"), idCard.issueDate)}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"id-card-" + index + "-expiration-date"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.label.expiryDate")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"id-card-" + index + "-expiration-date"}>
                                                {idCard.expirationDate && getFormattedDate(i18nService.get("Country"), idCard.expirationDate)}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"id-card-" + index + "-notes"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.label.notes")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"id-card-" + index + "-notes"}>
                                                {idCard.notes}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row between-xs margin-top-l">
                                    <div className="col-xs flex-grow-null col-no-gutter"></div>
                                    <div className="col-xs flex-grow-null col-no-gutter">
                                        <ul className="list-reset list-inline">
                                            <li>
                                                <button
                                                    type="button"
                                                    className="btn-default btn-red-outline btn-no-border"
                                                    onClick={() => showDeleteWalletDialog(idCard)}
                                                >
                                                    <span className="btn-icon">
                                                        <em className="las la-trash-alt"></em>
                                                    </span>
                                                    <span className="btn-text">
                                                        {tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.deleteButtonText")}
                                                    </span>
                                                </button>
                                            </li>
                                            <li className="margin-left-xs">
                                                <button
                                                    type="button"
                                                    className="btn-default btn-primary-outline"
                                                    id={"edit-id-card-" + index}
                                                    onClick={() => showIdCardDialog(idCard)}
                                                >
                                                    <span className="btn-icon">
                                                        <em className="las la-edit-alt"></em>
                                                    </span>
                                                    <span className="btn-text">
                                                        {tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.editDetailsButtonText")}
                                                    </span>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}

            {/* Delete modal*/}
            {deleteWalletDialogIsVisible && (
                <DialogComponent dialogId="dialog-delete-id-card-wallet" title="Delete Wallet" closeDialog={closeDeleteWalletDialog}>
                    <ConfirmDeleteWalletDialog
                        requestDataCallback={props.requestDataCallback}
                        closeDialog={closeDeleteWalletDialog}
                        walletItem={selectedItem}
                        itemType="id-card"
                    />
                </DialogComponent>
            )}

            {/* Edit modal*/}
            {idCardDialogIsVisible && (
                <DialogComponent dialogId="dialog-edit-social-security-card-wallet" title="Edit Social Security Card Wallet" closeDialog={closeIdCardDialog}>
                    <IdCardDialog requestDataCallback={props.requestDataCallback} closeDialog={closeIdCardDialog} walletItem={selectedItem} isNew={false} />
                </DialogComponent>
            )}
        </React.Fragment>
    );
};

export default IdCard;
